<template>
    <tr role="row" class="">
        <td aria-colindex="1" role="cell" style="width: 50%">{{ row.translation['en'].name }}</td>
        <td aria-colindex="2" role="cell" style="width: 35%">
            <div class="progress lg-progress-bar">
                <div role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="50"
                     class="progress-bar bg-success progress-bar-striped"
                     :style="{ width: (allSteps == 0 ? 0 : Math.round((finishedSteps / allSteps) * 100)) + '%'}">
                    {{ allSteps == 0 ? '0' : Math.round((finishedSteps / allSteps) * 100) }}%
                </div>
            </div>
        </td>
        <!--    <td style="width: 15%">{{ finishedSteps }} of {{ allSteps }} completed</td>-->
    </tr>
</template>

<script>

export default {
    props: {
        row: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    computed: {
        finishedSteps: function () {

            let count = 0

            this.row.steps.forEach((item) => {
                if (item.project_steps.is_active == 3) {
                    count++
                }
            })

            return count
        },
        allSteps: function () {

            let allSteps = this.row.steps.length
            return allSteps
        }
    }
}

</script>

<style>

.card h5 {
    color: #7366ff;
}

.main-menu .nav-item {
    cursor: pointer;
}

.step-selected {
    background-color: rgba(115, 102, 255, 0.15);
    -webkit-transition: all 0.5s ease;
    transition: all 0.5s ease;
    color: #7366ff;
}

.card-description * {
    color: #2c323f !important;
}

</style>